module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("j7Nvo"))).then(() => module.bundle.root('d0iPb'));